export default function parseJSON(string: string) {
  return JSON.parse(string);
}
